import React from 'react';
import { peopleProfiles, linkedInPosts } from '../utils/mockData';
import { MessageSquareIcon, ThumbsUpIcon, ShareIcon, RefreshCwIcon, ZapIcon, ArrowRightIcon } from 'lucide-react';
interface EngagementContextProps {
  personId: number;
  onGenerateMessage: (context?: string) => void;
}
export const EngagementContext: React.FC<EngagementContextProps> = ({
  personId,
  onGenerateMessage
}) => {
  const person = peopleProfiles.find(p => p.id === personId);
  if (!person) return null;
  const getPostById = (postId: number) => {
    return linkedInPosts.find(post => post.id === postId);
  };
  // Extract topics of interest based on interactions
  const getTopicsOfInterest = () => {
    const topics = new Set<string>();
    person.interactions.forEach(interaction => {
      const post = getPostById(interaction.postId);
      if (!post) return;
      // Extract potential topics from post content and comments
      const content = (post.content + (interaction.comment || '')).toLowerCase();
      if (content.includes('sales')) topics.add('sales');
      if (content.includes('marketing')) topics.add('marketing');
      if (content.includes('lead')) topics.add('lead generation');
      if (content.includes('strategy')) topics.add('strategy');
      if (content.includes('growth')) topics.add('growth');
      if (content.includes('technology')) topics.add('technology');
      if (content.includes('ai') || content.includes('artificial intelligence')) topics.add('AI');
      if (content.includes('data')) topics.add('data');
    });
    return Array.from(topics);
  };
  const topicsOfInterest = getTopicsOfInterest();
  return <div className="bg-white rounded-lg shadow-sm border border-gray-200 p-4 mb-6" data-id="element-387">
      <h3 className="text-md font-medium text-gray-900 mb-3 flex items-center" data-id="element-388">
        <ZapIcon size={16} className="text-[#f9b30f] mr-2" data-id="element-389" />
        Engagement Context
      </h3>
      {topicsOfInterest.length > 0 && <div className="mb-4" data-id="element-390">
          <div className="text-sm text-gray-600 mb-2" data-id="element-391">Topics of interest:</div>
          <div className="flex flex-wrap gap-2" data-id="element-392">
            {topicsOfInterest.map((topic, index) => <span key={index} className="px-2.5 py-1 bg-blue-50 text-blue-700 rounded-full text-xs font-medium" data-id="element-393">
                {topic}
              </span>)}
          </div>
        </div>}
      <div className="space-y-3" data-id="element-394">
        {person.interactions.map((interaction, index) => {
        const post = getPostById(interaction.postId);
        if (!post) return null;
        const interactionIcon = interaction.type === 'liked' ? <ThumbsUpIcon size={14} className="text-blue-600" data-id="element-395" /> : interaction.type === 'commented' ? <MessageSquareIcon size={14} className="text-purple-600" data-id="element-396" /> : <ShareIcon size={14} className="text-green-600" data-id="element-397" />;
        return <div key={index} className="p-3 bg-gray-50 rounded-md border border-gray-200" data-id="element-398">
              <div className="flex items-start" data-id="element-399">
                <div className="flex-shrink-0 mt-1" data-id="element-400">{interactionIcon}</div>
                <div className="ml-2 flex-1" data-id="element-401">
                  <p className="text-xs text-gray-500" data-id="element-402">
                    {interaction.type === 'liked' ? 'Liked a post' : interaction.type === 'commented' ? 'Commented on a post' : 'Shared a post'}{' '}
                    {interaction.date}
                  </p>
                  <p className="text-sm text-gray-800 line-clamp-2 mt-1" data-id="element-403">
                    "{post.content.substring(0, 100)}..."
                  </p>
                  {interaction.comment && <div className="mt-2 text-xs bg-white p-2 rounded border border-gray-200" data-id="element-404">
                      <span className="text-gray-500 block mb-1" data-id="element-405">
                        Their comment:
                      </span>
                      <span className="italic" data-id="element-406">"{interaction.comment}"</span>
                    </div>}
                  <button onClick={() => onGenerateMessage(`Based on their ${interaction.type === 'commented' ? 'comment' : 'engagement'} on a post about: "${post.content.substring(0, 100)}..."`)} className="mt-2 inline-flex items-center text-xs font-medium text-[#f9b30f] hover:text-[#e0a40e]" data-id="element-407">
                    Generate message from this context
                    <ArrowRightIcon size={12} className="ml-1" data-id="element-408" />
                  </button>
                </div>
              </div>
            </div>;
      })}
      </div>
      {person.interactions.length === 0 && <div className="text-center p-4" data-id="element-409">
          <p className="text-sm text-gray-500" data-id="element-410">No engagement data available.</p>
        </div>}
      <button onClick={() => onGenerateMessage(`Based on all engagement data from ${person.name}`)} className="mt-4 w-full inline-flex justify-center items-center px-4 py-2 border border-[#f9b30f] text-sm font-medium rounded-md text-[#f9b30f] bg-white hover:bg-[#fff8e8] focus:outline-none" data-id="element-411">
        <RefreshCwIcon size={16} className="mr-2" data-id="element-412" />
        Generate from all engagement
      </button>
    </div>;
};